export const regex = {
    // Standard email format
    email: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,

    // Phone number should only be 9 digits long (because of the country code)
    phone: /^[0-9]{9}$/,

    // If input is likely to be an email (if starts with a letter, or 1 to 3 digits followed by a letter)
    determineEmail:
        /^[a-zA-Z][a-zA-Z0-9@\-_.]*$|^[0-9][a-zA-Z][a-zA-Z0-9@\-_.]*$|^[0-9]{2}[a-zA-Z][a-zA-Z0-9@\-_.]*$|^[0-9]{3}[a-zA-Z][a-zA-Z0-9@\-_.]*$/,

    // If input is likely to be a phone number (if starts with 4 digits or more)
    determinePhone: /^[0-9]{4,}$/,

    // For inputs that can be either email or phone number, only allow letters, numbers, @, -, _, and .
    allowedCharsInEmailPhoneInput: /^[a-zA-Z0-9@\-_.]*$/,

    // Regex for validating usernames (Latin and Arabic characters allowed)
    username: /^[A-Za-z\u0600-\u06FF]+(-[A-Za-z\u0600-\u06FF]+)*$/,

    // Password requirements:
    // - 8-128 characters
    // - At least one uppercase letter
    // - At least one lowercase letter
    // - At least one number
    // - Special characters are allowed but not required
    // - No whitespace allowed
    password:
        /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[A-Za-z\d!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]{8,128}$/,

    // allow only english or arabic letters, minimum 2 characters
    name: /^[A-Za-z\u0600-\u06FF]{2,}$/,

    // Digits only
    digitsOnly: /^[0-9]*$/,

    // letters only (from any language)
    lettersOnly: /^[\p{L}]*$/u,

    // date of birth and must be at least 15 years old
    birth_date: /^(19|20)\d{2}-(0[1-9]|1[0-2])-(0[1-9]|[12][0-9]|3[01])$/,

    // is mobile device
    isMobileDevice:
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i,
}
